export default {
    selectAll: 'Select All',
    next: 'Next',
    discard: 'Discard',
    close: 'Close',
    cancel: 'Cancel',
    search: 'Search',
    apply: 'Apply',
    confirm: 'Confirm',
    create: 'Create',
    edit: 'Edit',
    cleanFilters: 'Clean Filters',
    remove: 'Remove',
    duplicate: 'Duplicate',
    editName: 'Edit name',
    save: 'Save',
    default: 'Set as Default',

    retry: {
        text: 'An error ocurred.',
        link: 'Click here to try again',
    },
}
